import React from 'react';
import SEO from './SEO';

function GameRules() {
  return (
    // ---- बदलाव यहाँ किया गया है ----
    // हमने mt-20 (margin) को pt-28 (padding) से बदल दिया है
    // ताकि कंटेंट fixed header के पीछे न छिपे।
    // px-4 मोबाइल पर साइड में स्पेस देता है और pb-12 नीचे स्पेस देता है।
    <div className="flex flex-col items-center min-h-screen bg-gray-100 pt-28 px-4 pb-12">
      <SEO
        title="Game Rules - Satta Matka"
        description="Learn the rules of Satta Matka, how to play, deposit & withdrawal guidelines, winning strategies, and the history of this popular game."
        keywords="Satta Matka rules, how to play Satta Matka, Satta Matka deposits, Satta Matka withdrawals, Satta Matka history"
      />
      {/* Content Card */}
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-xl p-6 sm:p-8 lg:p-10">
        
        <h1 className="text-3xl sm:text-4xl font-bold text-center mb-8 text-gray-800 border-b pb-4">
          Game Rules: Satta Matka
        </h1>

        {/* Introduction Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3 text-gray-700">What is Satta Matka?</h2>
          <p className="text-gray-600 mb-4 leading-relaxed">
            Satta is a broad word for "betting" in India. The Matka game, often called Indian Satta Matka, is a popular lottery-style numbers game. It originated before India's independence and involves picking numbers to win.
          </p>
          <p className="text-gray-600 leading-relaxed">
            The game is simple to understand. With a little study and effort, you can learn to play. The two most famous markets are the Kalyan Matka, introduced by Kalyanji Bhagat in 1962, and the Waroli Matka, introduced in the '70s by Ratan Khatri.
          </p>
        </div>

        {/* How to Play Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-700">How to Play (on Gama567)</h2>
          <ol className="list-decimal list-inside space-y-5 text-gray-600">
            <li>
              <strong>Pick your first set of numbers:</strong> Choose three (3) numbers from 0 to 9.
              <br />
              <em className="text-sm">For example:</em> <code className="bg-gray-200 text-gray-800 p-1 rounded-md">5, 3, 6</code>.
            </li>
            <li>
              <strong>Calculate the final number (Panna):</strong> Add the three numbers together. (e.g., <code className="bg-gray-200 text-gray-800 p-1 rounded-md">5 + 3 + 6 = 14</code>).
            </li>
            <li>
              <strong>Take the last digit:</strong> Use only the last digit of the sum. In this example, it's <code className="bg-gray-200 text-gray-800 p-1 rounded-md">4</code>.
              <br />
              Your first draw is then <code className="font-bold bg-yellow-200 text-yellow-800 p-1 rounded-md">5, 3, 6 * 4</code>.
            </li>
            <li>
              <strong>Repeat for the second set:</strong> The process is repeated for a second set of numbers.
              <br />
              <em className="text-sm">For example:</em> Let's say you pick <code className="bg-gray-200 text-gray-800 p-1 rounded-md">8, 2, 8</code>. The sum is <code className="bg-gray-200 text-gray-800 p-1 rounded-md">18</code>. The last digit is <code className="bg-gray-200 text-gray-800 p-1 rounded-md">8</code>.
              <br />
              Your second draw is <code className="font-bold bg-yellow-200 text-yellow-800 p-1 rounded-md">8, 2, 8 * 8</code>.
            </li>
            <li>
              <strong>Your final card (Jodi):</strong> Your complete ticket or card would look like this: <code className="text-lg font-mono font-bold bg-green-200 text-green-800 p-2 rounded-md">5,3,6 * 4 X 8,2,8 * 8</code>.
            </li>
          </ol>
        </div>

        {/* Deposits and Withdrawals Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-700">Deposits & Withdrawals</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>Minimum Deposit is <span className="font-semibold text-gray-800">₹100</span>.</li>
            <li>Minimum Withdrawal is <span className="font-semibold text-gray-800">₹1,000</span>.</li>
            <li>Maximum Withdrawal is <span className="font-semibold text-gray-800">₹25 Lakh</span> per day.</li>
            <li>Withdrawal requests can be placed between 11 am to 11 pm, all 7 days.</li>
            <li>Withdrawals are processed within 60 minutes and are available on Saturday & Sunday.</li>
            <li>Withdrawals are not available on festival days.</li>
            <li>1 Point in your wallet is equal to ₹1.</li>
          </ul>
          <div className="mt-5 p-4 bg-blue-100 border-l-4 border-blue-500 text-blue-800">
            <p><strong>Note:</strong> In case of any inconvenience or queries regarding transactions, you can WhatsApp us on <strong>+91 7737290102</strong>.</p>
          </div>
        </div>

        {/* Winning and Payouts Section */}
        <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-gray-700">How to Win: Payouts & Odds</h2>
            <p className="text-gray-600 mb-4 leading-relaxed">
                To win at Satta Matka, you have various payout rates, ranging from 9/1 to 999/1. You can bet on different chances, such as the first number, last number, or the combination (jodi). It is a game of chance and requires luck to win.
            </p>
            <h3 className="text-xl font-semibold mb-3 text-gray-700">Payout Example (for a ₹10 bet):</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>If you choose the correct first number drawn: <span className="font-semibold text-gray-800">9 x ₹10 = ₹90</span>.</li>
                <li>If your second number is drawn correctly: <span className="font-semibold text-gray-800">9 x ₹10 = ₹90</span>.</li>
                <li>If you choose the correct middle number (the jodi) and the first number in combination: <span className="font-semibold text-gray-800">90 x ₹10 = ₹900</span>.</li>
            </ul>
        </div>

        {/* History Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3 text-gray-700">History of Satta Matka</h2>
          <p className="text-gray-600 leading-relaxed">
            The origins of Matka gambling involved wagering on the opening and closing prices of cotton from the New York Cotton Exchange. The legendary Ratan Khatri, known as the Matka King, was a key figure in its history. After his arrest in 1995, the game's popularity shifted, but his name remains legendary in Mumbai's Satta Matka scene.
          </p>
        </div>

        {/* Legality and Online Play Section */}
        <div>
          <h2 className="text-2xl font-semibold mb-3 text-gray-700">Legality & Online Play</h2>
          <p className="text-gray-600 leading-relaxed">
            Satta is not currently legal in India, but it remains a large business. Online lotteries have grown in popularity, allowing players from India to participate in international games with larger jackpots. While many still bet with local bookies, more are shifting to online casinos and bookmakers for sports and other casino games.
          </p>
        </div>

      </div>
    </div>
  );
}

export default GameRules;